import { Outlet } from "react-router-dom";

export default function BillingLayout() {
  return <Outlet />; // This is crucial - without this, child routes can't render
}
